import Button from "@/components/base/Button";

interface SuccessPanelProps {
  numero: string;
  onReset: () => void;
}

const nextSteps = [
  "Regístrate y registra tus vehículos.",
  "Verificamos tu información.",
  "Activamos tu perfil si es aprobado.",
  "Recibes oportunidades compatibles con tu disponibilidad.",
];

export default function SuccessPanel({ numero, onReset }: SuccessPanelProps) {
  return (
    <div className="rounded-lg border border-accent-300 bg-background-50 p-6 text-center md:p-10">
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-700">
        <i className="ri-checkbox-circle-line text-3xl leading-none" aria-hidden="true"></i>
      </span>
      <h2 className="mt-5 text-2xl font-heading font-bold text-foreground-950 md:text-3xl">
        Solicitud recibida
      </h2>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
        Hemos recibido tu solicitud para formar parte de AXONIA GROUP. Nuestro equipo revisará la
        información proporcionada y se pondrá en contacto contigo si necesitamos información
        adicional o para continuar el proceso.
      </p>

      <div className="mx-auto mt-6 inline-flex flex-col items-center rounded-lg border border-background-200 bg-background-100 px-8 py-5">
        <span className="text-xs font-label font-semibold uppercase tracking-[0.18em] text-foreground-500">
          Número de solicitud
        </span>
        <span className="mt-1 text-2xl font-heading font-bold tracking-wide text-primary-700 md:text-3xl">
          {numero}
        </span>
      </div>

      <div className="mx-auto mt-8 max-w-2xl rounded-lg border border-background-200 bg-background-100 p-5 text-left">
        <h3 className="text-sm font-heading font-semibold text-foreground-950">¿Cómo continúa el proceso?</h3>
        <ol className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {nextSteps.map((step, index) => (
            <li key={step} className="flex items-start gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-label font-semibold text-primary-700">
                {index + 1}
              </span>
              <span className="text-sm text-foreground-700">{step}</span>
            </li>
          ))}
        </ol>
      </div>

      <p className="mx-auto mt-5 max-w-md text-xs text-foreground-500">
        Guarda tu número de solicitud. Te enviaremos un correo de confirmación con estos datos.
      </p>

      <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
        <Button to="/" variant="primary" size="md" icon="ri-home-5-line">
          Volver al inicio
        </Button>
        <Button variant="outline" size="md" icon="ri-add-line" onClick={onReset}>
          Enviar otra solicitud
        </Button>
      </div>
    </div>
  );
}